import {Component, ViewChild} from "@angular/core";
import {CreManagementSearchFormComponent} from './cre-management-search-form/cre-management-search-form.component';
import {CreManagementSearchResultsComponent} from "@tva/ng-migration/cre-tracking/components/search/cre-management-search-results/cre-management-search-results.component";
import {PathwaySchoolCourse} from "@tva/ng-migration/cre-tracking/models";
import {PathwayConstants} from "@tva/ng-migration/cre-tracking/components/search/cre-management-search-results/pathway/pathway.constants";

@Component({
  selector: "app-cre-management",
  templateUrl: "./cre-management.component.html",
  styleUrls: ["./cre-management.component.css"],
})
export class CreManagementComponent{
  pathways: [];
  school: any;
  schoolCourses: PathwaySchoolCourse[];

  @ViewChild(CreManagementSearchFormComponent) searchForm;
  @ViewChild(CreManagementSearchResultsComponent) resultsDisplay;

  constructor() {}

  public hasSearched({pathways, school, schoolCourses}): void {
    this.pathways = pathways;
    this.school = school;
    this.schoolCourses = this.prepareSchoolCourses(schoolCourses);
    this.resultsDisplay.reset();
  }

  private prepareSchoolCourses(schoolCourses: PathwaySchoolCourse[]): PathwaySchoolCourse[]{
      return [...schoolCourses, PathwayConstants.non_k12_course];
  }
}
